var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "library__card card",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.downloadPricing($event)
        }
      }
    },
    [
      _c("div", { staticClass: "card__logo-container" }, [
        _c("div", { staticClass: "card__logo-wrapper" }, [
          _vm.vendor.logoURL
            ? _c("img", {
                staticClass: "card__logo",
                attrs: { src: _vm.decode(_vm.vendor.logoURL) }
              })
            : _c("span", {
                staticClass: "fa fa-adjust card__placeholder",
                attrs: { "aria-hidden": "true" }
              })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__title" }, [
        _vm._v(_vm._s(_vm.vendor.name))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__description" }, [_vm._v(" ")]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__view-btn" }, [
      _vm._v("Download "),
      _c("span", {
        staticClass: "glyphicon glyphicon-download",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }